export function VendorInvoiceAttachItemsCtrl (
  $rootScope,
  $scope,
  $translate,
  $uibModalInstance,
  invoices,
  sessionObjAPI,
  tableApi,
  workshopAPI
) {
  $scope.company       = sessionObjAPI.company();
  $scope.invoices      = invoices;
  $scope.regoLabel     = $scope.company.company_variable_fields.plate_number_name || sessionObjAPI.countrySettings().rego_label;
  $scope.tableCacheKey = 'vendorInvoiceItemsAttach';

  $scope.selectedItems = [];

  $scope.filtering = tableApi.setFiltersFromCache($scope.tableCacheKey, {
    value: ''
  });

  $scope.tableSettings = {
    broadcast: 'filterInvoices',
    cache    : {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        classes: 'text-left',
        field  : 'job_card_number',
        header : {
          text: $translate.instant('MENU_SPACE.JOB_CARD')
        }
      },
      {
        classes: 'text-left',
        field  : 'post_date',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe    : 'date',
        pipeArgs: 'mediumDate'
      },
      {
        classes: 'text-left',
        field  : 'display_name',
        header : {
          text: $translate.instant('CUSTOMER_SPACE.CUSTOMER')
        }
      },
      {
        classes: 'text-left',
        field  : 'vehicle_details',
        header : {
          text: $scope.regoLabel
        }
      },
      {
        classes: 'text-left',
        field  : 'description',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        classes: 'text-left',
        field  : 'cost',
        header : {
          text: $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/invoices/invoice_list_for_linking_count', [
        'O', 'I-U',
        $scope.filtering.value || '*'
      ])
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'desc',
      field    : 'job_card_number'
    })
  };

  $scope.onRowClick = function () {
    $scope.selectedItems = $scope.invoices.filter((row) => row.selected);
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.select(event.row);
  };

  $scope.select = function (invoice) {
    $uibModalInstance.close(invoice);
  };

  $scope.getInvoices = ( params ) => {
    return workshopAPI.get('/invoices/invoice_list_for_linking', [
      params.offset,
      params.pageSize,
      'O',
      'I-U',
      params.field,
      params.direction,
      $scope.filtering.value || '*'
    ]).then(invoices => {
      $scope.invoices = invoices;

      return invoices;
    });
  };

  $scope.$watch('[filtering.value]', (newVal, oldVal) => {
    if (newVal !== oldVal) {
      window['filterInvoices']($scope.filtering);
    }
  }, true);
}